/* 
This class handles reading and writing browser cookies.
*/
export class Cookie {
  static read(name: string) {
    var result = new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)').exec(document.cookie);
    return result ? result[1] : null;
  }

  static write(name: string, value: string, days?: number) {
    let expires = "";

    // If days is specified, set an expiration date.
    // No days specified means cookie will expire when browser is closed
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  static remove(name: string) {
    Cookie.write(name, "", -1);
  }

  static exists(name: string): boolean {
    var prop = Cookie.read(name);
    if (prop != null && prop.length > 0)
      return true;
    else
      return false;
  }
}